import React, { useMemo, useEffect } from "react";
import {
  createDxpClickHandler,
  getUserData,
  getDXPRegistrationLink,
} from "../../Helpers/utils";
import { resolveTemplateExternalHref } from "../Common/StandaloneFormViews/resolveExternalHref";
import DxpPageShell from "../Common/StandaloneFormViews/DxpPageShell";
import { Link } from "../Common/spectrumCompat";
import { DxpBodyText, DxpHeading, DxpPrimaryButton } from "../dxpStandaloneUi";

function EmailMismatch() {
  const onAction = useMemo(() => createDxpClickHandler(), []);
  const userData = getUserData();
  const email = userData?.email || "";
  const searchedEmail =
    localStorage.getItem("email") ||
    localStorage.getItem("searchedEmail") ||
    "";

  useEffect(() => {
    const imsEmail = userData?.email || "";
    const searched = searchedEmail.trim();
    if (
      (!imsEmail && !searched) ||
      (imsEmail &&
        searched &&
        imsEmail.toLowerCase() === searched.toLowerCase())
    ) {
      localStorage.removeItem("emailMismatch");
      localStorage.removeItem("partnerRegistrationFormStep");
      window.location.href = getDXPRegistrationLink();
    }
  }, [searchedEmail, userData?.email]);

  const aemHomeHref = resolveTemplateExternalHref({
    endpointPath: "environment.aemHomePageUrl",
    redirect: {
      type: "external",
      path: "/technologyprogram/experiencecloud/home.html",
    },
  });

  return (
    <DxpPageShell requireCommonHeaders>
      <div className="dxp-email-mismatch-outer">
        <div className="dxp-email-mismatch-card-shell">
          <DxpHeading className="dxp-heading--fs-24">Email Mismatch</DxpHeading>
          <DxpBodyText>
            The email that you searched, {searchedEmail} and the ADOBE ID,{" "}
            {email}, that you signed in do not match.
          </DxpBodyText>
          <DxpBodyText>
            Click <b>Continue</b> to see search results for your Adobe ID,{" "}
            {email}. Click <b>Go back</b> to sign out and search again.
          </DxpBodyText>
          <div className="dxp-email-mismatch-actions-row">
            <DxpPrimaryButton
              label="Continue"
              onPress={() => onAction({ actionType: "continue" })}
            />
            <DxpPrimaryButton
              label="Go back"
              onPress={() => onAction({ actionType: "goBack" })}
            />
          </div>
          {aemHomeHref ? (
            <div className="dxp-mt-24">
              <Link
                href={aemHomeHref}
                target="_blank"
                rel="noopener noreferrer"
                UNSAFE_className="dxp-float-start-link"
              >
                Go to the Digital Experience Program home page
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    </DxpPageShell>
  );
}

export default EmailMismatch;
